import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=3b5b579f&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b5b579f')) {
      api.createRecord('3b5b579f', component.options)
    } else {
      api.reload('3b5b579f', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=3b5b579f&", function () {
      api.rerender('3b5b579f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DMs6l0pgtc92/JS/ImageCarousel.vue"
export default component.exports